<div class="modal-header red_alert">
  <h3 class="modal-title">ACHTUNG!</h3>
</div>

<div class="modal-body red_alert">
  @if (message === 'ProductionOrOrder') {
    <div>
      Mindest Lagerbestand unterschritten. Bitte Produktionsauftrag oder Bestellung erstellen.
    </div>
  }
  @if (message === 'MinimumInventoryAndCustomerApproval') {
    <div>
      Mindest Lagerbestand unterschritten und Produktionsfreigabe erreicht. Bitte Kundenfreigabe einholen.
    </div>
  }
  @if (message ==='CustomerApproval') {
    <div>
      Produktionsfreigabe erreicht. Bitte Kundenfreigabe einholen.
    </div>
  }
  @if (message ==='MinimumInventory') {
    <div>
      Mindest Lagerbestand unterschritten.
    </div>
  }
</div>

<div class="modal-footer red_alert">
  <button class="btn btn-default pull-left" (click)="close()">Schließen</button>
</div>
